import type { WShopPromotionalProductsTranslations } from "./pl";

export const de: WShopPromotionalProductsTranslations = {
  title: "Angebote",
  showAll: "Alle anzeigen",
  noProducts: "Keine Produkte im Angebot.",
};
